module.exports = __webpack_public_path__ + "static/media/digital-marketing-introduce-2.c9334519.png";